import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { 
  SharedDataService, 
  SuppliersService,
  PS_Indicateurs_Result
 } from 'ngx-paf-common';
import { PilotageEndelTabComponent } from '../pilotage-endel-tab/pilotage-endel-tab.component';

@Component({
  selector: 'pilotage-criticite',
  templateUrl: './pilotage-criticite.component.html',
  styleUrls: ['./pilotage-criticite.component.scss']
})
export class PilotageCriticiteComponent
    extends PilotageEndelTabComponent 
    implements OnInit, OnChanges {

  constructor(
    public sharedDataSvc:SharedDataService,
    private suppliersSvc:SuppliersService) { 
      super(sharedDataSvc);
    }

  reloadTab(): void {
      this.reloadIndicateurs();
  }

  

  ngOnChanges(changes: SimpleChanges): void {
    this.reloadTab();
  }

  indicateurs: PS_Indicateurs_Result[]=[];
  
  ngOnInit(): void {
    this.reloadIndicateurs();
  }

  reloadIndicateurs():void{
    this.loading=true;
    if ((this.supplierId||0)>0){
      this.suppliersSvc.GetIndicateurs(this.supplierId)
      .subscribe(res=> {
        this.indicateurs=res;
        this.loading=false;
      });
    } else {
      this.indicateurs=[];
      this.loading=false;
    }
  }

  detailLines(item:PS_Indicateurs_Result): string[]{
    return item.Detail?.split('|');
  }

  public indicateurClass(indicateurCod:string){
    switch ((indicateurCod||'').toLowerCase()){
      case 'vert':
        return 'indicateur indicateur-vert';
      case 'orange':
        return 'indicateur indicateur-orange';
      case 'rouge':
        return 'indicateur indicateur-rouge';
      default:
        return 'indicateur indicateur-nc';
    }
  }
}
